import React, { useState, useEffect } from 'react'
import { Box, Title, Card, Flex, Text, Group, Switch, Badge, Loader, Divider, Button, Modal } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../services/orders'
import { getAllQcList } from '../../../../services/quality-control'
import { useViewportSize } from '@mantine/hooks'
import { getOrderDetail } from '../../../../store/orderDetail'
import { IconPlus } from '@tabler/icons-react'
import NoData from '../../../ui/NoData'
import LoadingData from '../../../ui/LoadingData'
import OrderGeneralQcList from './LayoutHelper/OrderGeneralQcList'
import OrderItemsQcTable from './LayoutHelper/OrderItemsQcTable'
import FormAddOrderQc from './Form/FormAddOrderQc'

const labelTable = [
  {
    label: 'Product Name',
    width: 'auto'
  },
  {
    label: 'QC Status',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const OrderQualityControl = () => {
  const dispatch = useDispatch()
  const { width } = useViewportSize()
  const params = useParams()
  const orderId = params.order_id
  const { isLoadingOrder, general, showQC } = useSelector(state => state.order_detail)
  const { isLoadingOrderItems, dataOrderItems } = useSelector(state => state.order_items)
  const [loadingQc, setLoadingQc] = useState(false)
  const [loadingOrderQc, setLoadingOrderQc] = useState(true)
  const [generalQcList, setGeneralQcList] = useState([])
  const [loadingItemsQc, setLoadingItemsQc] = useState(true)
  const [itemsQcList, setItemsQcList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)

  const handleChangeStatusQC = async (statusChecked) => {
    setLoadingQc(true)
    const payload = {
      order_infos: {
        billing: general.billingInformation,
        shipping: general.shippingInformation,
        show_qc: statusChecked
      }
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        dispatch(getOrderDetail(orderId))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingQc(false)
    }
  }

  const handleGetQcOrder = async () => {
    setLoadingOrderQc(true)
    const params = {
      'page[limit]': 100,
      sort: '-id',
      'filter[order_id][in]': orderId,
      include: 'qcGroup,items',
    }
    try {
      const response = await getAllQcList(params)
      if (response.success) {
        const includedItems = Object.values(response.included.items) || []
        const remapDataQcItems = includedItems.map((val) => {
          return val.attributes
        })
        setGeneralQcList(remapDataQcItems)
      } else {
        setGeneralQcList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingOrderQc(false)
    }
  }

  const handleGetQcOrderItems = async () => {
    setLoadingItemsQc(true)
    const getProductId = dataOrderItems.map((val) => {
      return val.id
    })
    const params = {
      'page[limit]': 100,
      sort: '-id',
      'filter[order_item_id][in]': getProductId.toString(),
      include: 'qcGroup,items',
    }
    try {
      const response = await getAllQcList(params)
      if (response.success) {
        const resDataQcItems = response.data

        const remapDataQc = resDataQcItems.map((val) => {
          return val.attributes
        })

        const remapData = dataOrderItems.map((val) => {
          return {
            id: val.id,
            product_name: val.productName,
            quantity: val.quantity,
            unitName: val.unit_name,
            qc_result: remapDataQc.filter((value) => value.order_item_id === val.id)
          }
        })

        setItemsQcList(remapData)
      } else {
        const remapData = dataOrderItems.map((val) => {
        return {
          id: val.id,
          product_name: val.productName,
          quantity: val.quantity,
          unitName: val.unit_name,
          qc_result: []
        }
      })
        setItemsQcList(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingItemsQc(false)
    }
  }

  useEffect(() => {
    handleGetQcOrder()
    // eslint-disable-next-line
  }, [orderId])

  const actions = {
    detail: (val) => {
      console.log(val)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
  }

  useEffect(() => {
    if (!isLoadingOrderItems) {
      if (dataOrderItems.length > 0) {
        handleGetQcOrderItems()
      } else {
        setLoadingItemsQc(false)
        setItemsQcList([])
      }
    }
    // eslint-disable-next-line
  }, [isLoadingOrderItems, dataOrderItems])

  const mappingFormStatusQC = () => {
    return (
      <Group align='center' gap='xs'>
        <Switch
          checked={showQC}
          onChange={(event) => handleChangeStatusQC(event.currentTarget.checked)}
          size='xs'
        />
        <Badge variant="light" color={showQC ? 'teal' : 'red'} tt='capitalize' fw='500'>{showQC ? 'Enabled' : 'Disabled'}</Badge>
      </Group>
    )
  }

  const remapDataQcGeneral = (data) => {
    if (data.length > 0) {
      const remapList = data.map((val, index) => {
        return (
          <Box mb={10}>
            <OrderGeneralQcList dataGeneralQc={val} reloadList={handleGetQcOrder} />
          </Box>
        )
      })
      return remapList
    }
  }

  return (
    <Box>
      <Box my={20}>
        <Title size={16} fw={500}>Quality Control</Title>
        <Box my={10} w={width / 3}>
          <Card withBorder shadow="xs" radius="md" padding='md' mb='lg'>
            <Flex justify='space-between' align='center'>
              <Text fz={12} fw='600'>Show QC</Text>
              {!isLoadingOrder && !loadingQc ? mappingFormStatusQC() : <Loader size='xs' />}
            </Flex>
          </Card>
        </Box>
      </Box>
      <Divider my='xs' />
      <Box my={20}>
        <Flex justify='space-between' align='center'>
          <Title size={16} fw={500}>QC Photo General</Title>
          <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add New</Button>
        </Flex>
        <Box my={20}>
          {loadingOrderQc ? <LoadingData /> : generalQcList.length > 0 ? remapDataQcGeneral(generalQcList) : <NoData />}
        </Box>
      </Box>
      <Divider my='xs' />
      <Box my={20}>
        <Title size={16} fw={500}>QC Photos per Product Items</Title>
        <Box my={20}>
          {loadingItemsQc ? <LoadingData /> : itemsQcList.length > 0 ? <OrderItemsQcTable label={labelTable} data={itemsQcList} actionMethod={handleAction} /> : <NoData />}
        </Box>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Add General QC for Order ID {orderId}</Text>} withCloseButton={false}>
        <FormAddOrderQc idOrder={orderId} idOrderItem={null} onCloseForm={onCloseModalForm} reloadList={handleGetQcOrder} />
      </Modal>
    </Box>
  )
}

export default OrderQualityControl